// Image optimization utilities for Shopify CDN and other image sources

/**
 * Generate optimized image URLs with Shopify CDN parameters
 * @param {string} src - Original image URL
 * @param {number} width - Desired width
 * @returns {string} - Optimized URL with width and format params
 */
export const getOptimizedImageUrl = (src, width = 800) => {
  if (!src) return '';
  
  // For Shopify CDN images, add size and format params
  if (src.includes('cdn.shopify.com')) {
    const separator = src.includes('?') ? '&' : '?';
    return `${src}${separator}width=${width}&format=webp`;
  }
  
  // For other images, return as-is
  return src;
};

/**
 * Generate srcset string for responsive images
 * @param {string} src - Original image URL
 * @param {number[]} widths - Array of widths for srcset
 * @returns {string} - srcset attribute value
 */
export const generateSrcSet = (src, widths = [400, 600, 800, 1200]) => {
  if (!src) return '';
  
  // For Shopify CDN images
  if (src.includes('cdn.shopify.com')) {
    const baseUrl = src.split('?')[0];
    return widths
      .map(w => `${baseUrl}?width=${w}&format=webp ${w}w`)
      .join(', ');
  }
  
  // For non-Shopify images, return empty (browser will use src)
  return '';
};

/**
 * Generate srcset for hero/large images
 * @param {string} src - Original image URL
 * @returns {string} - srcset for large images
 */
export const generateHeroSrcSet = (src) => {
  return generateSrcSet(src, [800, 1200, 1600, 2000]);
};

/**
 * Error handler for broken images
 * @param {Event} e - Error event
 */
export const handleImageError = (e) => {
  e.target.style.background = '#F5F0E8';
  e.target.style.minHeight = '300px';
  e.target.removeAttribute('src');
};

/**
 * Error handler with custom height
 * @param {Event} e - Error event
 * @param {string} height - Min height value
 */
export const handleImageErrorWithHeight = (e, height = '300px') => {
  e.target.style.background = '#F5F0E8';
  e.target.style.minHeight = height;
  e.target.removeAttribute('src');
};
